import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ESearchResultsActionType } from './types';

export const closeSearchResultsSidebar = actionGenerator<ESearchResultsActionType.SidebarClosed>(
  ESearchResultsActionType.SidebarClosed,
);
